module.exports = __webpack_public_path__ + "assets/3848656574f8c42e0f0ad493ae7afa95.png";